import {
  Activity,
  CalendarDays,
  Check,
  Plus,
  Settings as SettingsIcon,
  Sparkles,
  Wallet,
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import type { TabId } from '../screens/TabNavigator';

export interface WalkthroughStep {
  id: string;
  title: string;
  description: string;
  icon: LucideIcon;
  /** When this step becomes active, the navigator switches to this tab. */
  tab: TabId;
}

/**
 * Seven steps, exactly as the spec lays out — Today / Today / Today /
 * Activity / Plan / Settings / Today. The navigator subscribes to the
 * active step and switches tabs whenever the index moves.
 */
export const STEPS: WalkthroughStep[] = [
  {
    id: 'welcome',
    title: 'Welcome to Margin',
    description:
      'Track every dollar without thinking about it. Let’s take a quick tour.',
    icon: Sparkles,
    tab: 'today',
  },
  {
    id: 'hero',
    title: 'Your daily budget',
    description:
      'The big number is what you can spend today and stay on pace through your pay period.',
    icon: Wallet,
    tab: 'today',
  },
  {
    id: 'quick-add',
    title: 'Adding transactions',
    description:
      'Tap Add expense or Add income to log spending right from the home screen. No menus, no extra taps.',
    icon: Plus,
    tab: 'today',
  },
  {
    id: 'activity',
    title: 'Activity & history',
    description:
      'Every transaction lives here, grouped by day with running totals. Swipe a row left to delete it.',
    icon: Activity,
    tab: 'activity',
  },
  {
    id: 'plan',
    title: 'Plan ahead',
    description:
      'Recurring income, bills, and savings goals live here, plus a live visualization of your budget model.',
    icon: CalendarDays,
    tab: 'plan',
  },
  {
    id: 'settings',
    title: 'Make it yours',
    description:
      'Pick a theme, choose your accent, manage categories, or use the built-in calculators in Tools.',
    icon: SettingsIcon,
    tab: 'settings',
  },
  {
    id: 'done',
    title: "You're all set",
    description:
      'Margin is ready. Open the door and start tracking. You can replay this tour anytime from Settings → Help.',
    icon: Check,
    tab: 'today',
  },
];
